import { render, staticRenderFns } from "./select-input.vue?vue&type=template&id=0a3f44e0&"
import script from "./select-input.vue?vue&type=script&lang=js&"
export * from "./select-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports